import { render } from "./ModalCommentChanged.vue?vue&type=template&id=1b282404&scoped=true&ts=true"
import script from "./ModalCommentChanged.vue?vue&type=script&lang=ts"
export * from "./ModalCommentChanged.vue?vue&type=script&lang=ts"

import "./ModalCommentChanged.vue?vue&type=style&index=0&id=1b282404&lang=scss"
import "./ModalCommentChanged.vue?vue&type=style&index=1&id=1b282404&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b282404"]])

export default __exports__